var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDropdown = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1753963608368,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3352,
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M996.15907247 328.14500484L563.28904348 801.50013527a68.12063536 68.12063536 0 0 1-51.17031884 23.15130434c-19.58956521 0-38.22933334-8.42944927-51.17031885-23.15130434L28.07837681 328.14500484c-21.13298551-22.32023188-27.66284058-54.85078261-16.74017391-83.58214494s37.27953623-48.79582609 67.91049275-51.52649274h865.38388406c30.74968117 2.61194203 57.22527536 22.55768116 68.14794203 51.4077681 11.0413913 28.85008696 4.51153623 61.26191304-16.62144927 83.70086958z",
    "p-id": 3353,
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDropdown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-dropdown.9a67b2c8221afad167d52dfdedf4f1db.svg";